export const initialState = {
    expandLeadsStatuses: false,
    expandReports: false,
    expandLeads: false,
    expandUsers: false,
    expandFiles: false,
    expandNotes: false,
};

export default function dock(state = initialState, action) {
    switch (action.type) {
        case 'DOCK_EXPAND_LEADS_STATUSES':
            return {
                ...state,
                expandLeadsStatuses: action.value,
            };
        case 'DOCK_EXPAND_REPORTS':
            return {
                ...state,
                expandReports: action.value
            };
        case 'DOCK_EXPAND_LEADS':
            return {
                ...state,
                expandLeads: action.value
            };
        case 'DOCK_EXPAND_USERS':
            return {
                ...state,
                expandUsers: action.value
            };
        case 'DOCK_EXPAND_FILES':
            return {
                ...state,
                expandFiles: action.value
            };
        case 'DOCK_EXPAND_NOTES':
            return {
                ...state,
                expandNotes: action.value
            };
        default:
            return state;
    }
};
